import './App.css';
import WeatherApp from './components/WeatherApp/WeatherApp';
function App() {
  return (
  <WeatherApp></WeatherApp> 
  );
}

export default App;
